import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Fade out loading screen once React has painted
requestAnimationFrame(() => {
  setTimeout(() => {
    const loader = document.getElementById('app-loader');
    if (loader) {
      loader.classList.add('hidden');
      setTimeout(() => loader.remove(), 500);
    }
  }, 400);
});

// No service worker is registered. The app relies entirely on Netlify's
// no-cache headers for index.html to always serve the latest version.
// Any lingering SW registrations are cleaned up by the inline script in
// index.html before React even mounts.
